module.exports = __webpack_public_path__ + "img/newsreader_completed.ef182d9a.svg";